export default {
      id: "icon--acco-payment-usage",
      viewBox: "0 0 32 21",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--acco-payment-usage",
      toString: function () {
        return this.url;
      }
    }